export default __webpack_public_path__ + "static/media/component.218687bc.svg";